<template>
    <Teleport to="body">
      <div v-if="applicant" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md m-4">
          <!-- Modal Header -->
          <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
            <h3 class="text-lg font-medium text-[#035a76] dark:text-white">Update Applicant Status</h3>
            <button @click="$emit('close')" class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
  
          <!-- Modal Body -->
          <div class="px-6 py-4">
            <form @submit.prevent="saveStatus">
              <div class="space-y-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Applicant Name</label>
                  <p class="mt-1 text-sm text-gray-900 dark:text-white">{{ applicant.name }}</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Position</label>
                  <p class="mt-1 text-sm text-gray-900 dark:text-white">{{ applicant.position }}</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Status</label>
                  <select
                    v-model="localStatus"
                    required
                    class="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  >
                    <option v-if="hasPermission('manpower', 'validate')"  value="Validated">Validated</option>
                    <option v-if="hasPermission('manpower', 'reject')" value="Rejected">Rejected</option>
                    <option v-if="hasPermission('manpower', 'keep')" value="Kept">Kept</option>
                    <option v-if="hasPermission('manpower', 'process')" value="Processing">Processing</option>
                  </select>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Comment</label>
                  <textarea
                    v-model="localComment"
                    placeholder="Enter reason for this decision..."
                    rows="4"
                    class="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
  
          <!-- Modal Footer -->
          <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
            <button
              @click="$emit('close')"
              class="px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-300 dark:hover:bg-gray-500"
            >
              Cancel
            </button>
            <button
              @click="saveStatus"
              class="px-4 py-2 bg-secondary text-white rounded-md hover:bg-[#064b61] focus:outline-none focus:ring focus:ring-blue-300"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </template>
  
  <script setup>
  import { ref, watch } from 'vue';
  
  const props = defineProps({
    applicant: Object,
    initialStatus: String
  });
    import { usePermissions } from '@/composables/usePermissions'

const { hasPermission } = usePermissions()
  
    const backendURL = "http://localhost:8000/api/";

  const emit = defineEmits(['close', 'save']);
  
  const localStatus = ref(props.initialStatus);
  const localComment = ref(props.applicant?.applicant_comment || '');
  
  watch(
    () => props.initialStatus,
    (newStatus) => {
      localStatus.value = newStatus;
    }
  );
  
  const saveStatus = () => {
    emit('save', {
      applicant: props.applicant,
      status: localStatus.value,
      comment: localComment.value
    });
  };
  </script>